import React from "react";
import { ImageContainer } from "../../constants/ImagesConstants";
import { FormattedMessage } from "react-intl";
import LanguageSwitcher from "./LanguageSwitcher";

const AuthorSideBar = () => {
  return (
    <div className="sidebaarLeft">
      <div className="author-lang-switch">
        <LanguageSwitcher variant="light" />
      </div>
      <img alt="logo" src={ImageContainer?.AuthorSidebarImage} />
      <div className="hovertext">
        {/* <img alt="logo" src={ImageContainer?.LogoWhite} /> */}
        <img alt="logo" src={ImageContainer?.LogoSimbelImage} />
        <p>
          {" "}
          <FormattedMessage id="book_you" />
          <u>
            {" "}
            <FormattedMessage id="treatments" />
          </u>
          <FormattedMessage id="at_your" />{" "}
          <u>
            {" "}
            <FormattedMessage id="home" />
          </u>
          , <FormattedMessage id="your" />{" "}
          <u>
            {" "}
            <FormattedMessage id="office" />
          </u>{" "}
          <FormattedMessage id="or_hotel" />
        </p>
      </div>
    </div>
  );
};

// export default AuthorSideBar
export default React.memo(AuthorSideBar);
